import {
	BasicSelect
} from 'vue-search-select'
export default {
	name: 'Freight-Charges',
	components: {
		BasicSelect
	},
	props: ['rateTemplateDetailsObject','ratebasis'],
	data() {
		return {
			freightwttype:'',
			type: null
		}
	},
	computed: {},
	mounted() {

	},
	methods: {
		// selectBillWeight(data) {
		// 	this.selectedbillweight.value = data.value;
		// 	this.selectedbillweight.text = data.text;
		// },
		setValues(rateTemplateDetailsObject) {
			if (rateTemplateDetailsObject && rateTemplateDetailsObject.freightwttype) {
				this.freightwttype = rateTemplateDetailsObject.freightwttype
			}
		},
		saveOnTabChange(){
			this.saveFreightCharges("saveAndNext", true)
		},
		saveFreightCharges(type, isTabChange ) {
			this.type = type;
			let submitobject = {}
			if(this.ratebasis == 1){
				submitobject.freightwttype = 1
			}else if(this.ratebasis == 2){
				submitobject.freightwttype = 2
			}
			//if(this.rateTemplateId){
			if (type == "saveAndNext") {
				if(isTabChange){
					submitobject.isTabChange = isTabChange
				}
				this.$emit("saveandnext", submitobject)
			} else {
				this.$emit("save", submitobject)
			}
			// } else {
			//     this.$emit("createAndGetId", submitobject)
			// }
		},
		// saveAndNext(){
		//   this.saveFreightCharges('saveAndNext')
		// }
	}
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ratetemplate/createratetemplate/freightcharges/freightcharges.js